import * as React from 'react'
import { Redirect, Route } from 'react-router'

export const PrivateRoute = React.memo(({ component, ...rest }: any) => {
    const routeComponent = () => (rest.isAuthenticated ? component : <Redirect to={{ pathname: '/login' }} />)
    return <Route {...rest} render={routeComponent} />
})